import { PageHero, SectionHead, StatBlock, StoryCard, Reveal } from "../components/common";
import { IMPACT_STATS, STATS_DISCLAIMER, EVENTS } from "../data/site";

export default function Impact() {
  return (
    <>
      <PageHero
        overline="Impact"
        title="Evidence, Not Claims"
        copy="Every figure and story on this page comes from the Trust's own documented event reports. Where a number was never published, we say so — nothing here is illustrative or estimated."
      />
      <section className="pb-24 md:pb-32">
        <div className="max-w-[90rem] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {IMPACT_STATS.map((s, i) => (
              <StatBlock key={s.label} label={s.label} value={s.value} note={s.note} index={i} />
            ))}
          </div>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-2xl text-xs leading-relaxed text-charcoal/45">{STATS_DISCLAIMER}</p>
          </Reveal>
        </div>
      </section>
      <section className="py-24 md:py-32 bg-softgray">
        <div className="max-w-[90rem] mx-auto px-6 md:px-12">
          <SectionHead
            overline="From the Field"
            title="Stories of Impact"
            copy="The Trust's most recent documented events — real photography, real locations, real dates. The complete archive of 51 events lives on the Our Work page."
          />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {EVENTS.slice(0, 9).map((s, i) => (
              <StoryCard key={s.slug} story={s} index={i} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
